import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi';

const Contact = () => {
  return (
    <div className="pt-24 pb-20 bg-primary min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">Contact Us</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-6"></div>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
          
          {/* Info Side */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="lg:w-1/3 space-y-10"
          >
            <div>
              <h3 className="text-2xl font-display text-light mb-6">Studio Info</h3>
              <p className="text-muted mb-8 leading-relaxed">
                Have a general question or want to stop by? We're located right in the heart of downtown Montreal.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-background rounded-full text-secondary">
                    <SafeIcon icon={FiMapPin} />
                  </div>
                  <div>
                    <h5 className="text-light font-medium mb-1">Location</h5>
                    <p className="text-muted text-sm">1835 Saint Catherine Street W<br/>Montreal, QC H3H 1M2</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-background rounded-full text-secondary">
                    <SafeIcon icon={FiPhone} />
                  </div>
                  <div>
                    <h5 className="text-light font-medium mb-1">Phone</h5>
                    <p className="text-muted text-sm">(514) 555-0182</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-background rounded-full text-secondary">
                    <SafeIcon icon={FiMail} />
                  </div>
                  <div>
                    <h5 className="text-light font-medium mb-1">Email</h5>
                    <p className="text-muted text-sm">hello@blackanchortattoo.ca</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-3 bg-background rounded-full text-secondary">
                    <SafeIcon icon={FiClock} />
                  </div>
                  <div>
                    <h5 className="text-light font-medium mb-1">Hours</h5>
                    <p className="text-muted text-sm">Tue - Sat: 11:00 AM - 8:00 PM<br/>Sun - Mon: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Side */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="lg:w-2/3 bg-background p-8 md:p-10 border border-gray-800"
          >
            <h3 className="text-2xl font-display text-light mb-6">Send a Message</h3>
            <p className="text-muted text-sm mb-8">For tattoo bookings, please use our dedicated <a href="#/booking" className="text-secondary hover:underline">Booking Form</a>. Use this form for general inquiries only.</p>
            
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-muted mb-2">Name</label>
                  <input type="text" className="w-full bg-primary border border-gray-800 p-3 text-light focus:outline-none focus:border-secondary transition-colors" placeholder="John Doe" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-muted mb-2">Email</label>
                  <input type="email" className="w-full bg-primary border border-gray-800 p-3 text-light focus:outline-none focus:border-secondary transition-colors" placeholder="john@example.com" />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-muted mb-2">Subject</label>
                <input type="text" className="w-full bg-primary border border-gray-800 p-3 text-light focus:outline-none focus:border-secondary transition-colors" placeholder="How can we help?" />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-muted mb-2">Message</label>
                <textarea rows="5" className="w-full bg-primary border border-gray-800 p-3 text-light focus:outline-none focus:border-secondary transition-colors resize-none" placeholder="Your message here..."></textarea>
              </div>
              
              <button className="bg-secondary text-primary px-8 py-3 font-medium hover:bg-light transition-colors uppercase tracking-wider text-sm w-full">
                Send Message
              </button>
            </form>
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default Contact;